module.exports = __webpack_public_path__ + "img/vvv.f3f7e0e8.svg";